import { render, staticRenderFns } from "./mark-invoice-as-paid-button.vue?vue&type=template&id=39573cf8"
import script from "./mark-invoice-as-paid-button.vue?vue&type=script&lang=js"
export * from "./mark-invoice-as-paid-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports